// extracted by mini-css-extract-plugin
module.exports = {"displayField":"displayField_displayField__34ehq","label":"displayField_label__20Euf","value":"displayField_value__HYLif"};